<template>
    <div class="dia_container" v-loading="loading" element-loading-text="license数据加载中！">
        <div class="table">
            <div class="tr cl">
                <div class="th l">应用</div>
                <div class="th l">购买数</div>
                <div class="th l">最大数</div>
            </div>
            <div class="tr cl" v-for="item in apps">
                <div class="td l">{{item.appcode}}</div>
                <div class="td l"><el-input v-model="item.buylicense"></el-input></div>
                <div class="td l"><el-input v-model="item.maxlicense"></el-input></div>
            </div>
        </div>
        <div class="dia_btn_container">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="saveLicenceSet">保存</el-button>
        </div>
    </div>
</template>
<script>
    import { errorMessage } from '../../../util'
    export default {
        props: ['param'],
        data(){
            return {
                apps: [],
                loading: false
            }
        },
        created(){
            this.init()
        },
        methods: {
            init() {
                this.loading = true
                this.getSubApplications(this.param.productPackageCode).then(res => {
                    this.apps = []
                    this.initLicenseData(res.data.resp_data, this.param.tenantCode)
                }).catch(error => {
                    this.loading = false
                    errorMessage(error, this)
                })
            },
            initLicenseData(data, tenantCode){
                if(data && data.length > 0){
                    data.forEach(item => {
                        this.getLicenseData(tenantCode, item.appcode).then(res => {
                            this.loading = false
                            if(res.data.resp_data[0]){
                                this.apps.push(res.data.resp_data[0])
                            }
                        }).catch(error => {
                            this.loading = false
                            errorMessage(error, this)
                        })
                    })
                }
            },
            // 保存License数设置
            saveLicenceSet() {
                let licenses = []
                this.apps.forEach(item => {
                    let temp = {
                        appcode: item.appcode,
                        buylicense: item.buylicense,
                        maxlicense: item.maxlicense,
                        descr: ''
                    }
                    licenses.push(temp)
                })
                this.$http.post(`/platserv/tenantLicense/init`,
                {
                    licenses, 
                    tenantcode: this.param.tenantCode
                }).then(res => {
                    this.$message.success('设置license数成功！')
                    this.cancel()
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            cancel() {
                this.$emit('cancel')
            },
            // 加载应用列表
            getSubApplications(code) {
                return this.$http.post(`/platserv/subApplication/getSubApplications`,{productpackagecode: code})
            },
            // 加载应用license数据
            getLicenseData(tenantCode, appcode){
                return this.$http.post(`/platserv/tenantLicense/get`,{tenantcode: tenantCode, appcode})
            }
        }
    }
</script>


// WEBPACK FOOTER //
// SettingLicense.vue?387c3b00